import React, { Component } from "react";
import {
  Collapse,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
} from "reactstrap";
import { Outlet, Link } from "react-router-dom";
import Footer from "../components/FooterComponent";
import { motion } from "framer-motion";
import HelmetComponent from "../components/HelmetComponent";
class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNavOpen: false,
    };
    this.toggleNav = this.toggleNav.bind(this);
  }

  toggleNav() {
    this.setState({
      isNavOpen: !this.state.isNavOpen,
    });
  }

  render() {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <HelmetComponent />
        <header>
          <Navbar color="light" light sticky="top" expand="md">
            <NavbarBrand id="navbar-brand" href="/">
              Joe's Pressure Washing
            </NavbarBrand>
            <NavbarToggler onClick={this.toggleNav} />
            <Collapse isOpen={this.state.isNavOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem>
                  <Link className="nav-link" to="/about">
                    About
                  </Link>
                </NavItem>
                <NavItem>
                  <Link className="nav-link" to="/services">
                    Services
                  </Link>
                </NavItem>
                <NavItem>
                  <Link className="nav-link" to="/contact">
                    Contact
                  </Link>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        </header>
        <Outlet />
        <Footer />
      </motion.div>
    );
  }
}

export default Layout;
